// Viewport width and height
export const vw = window.innerWidth
export const vh = window.innerHeight

// Enum of available stage statuses
export const Status = Object.freeze({
    LOADING: Symbol('loading'),
    LOADED: Symbol('loaded'),
    COMPLETED: Symbol('completed'),
    NEXT: Symbol('next'),
})

// Enum of available Screen orientation lock types
export const ScreenOrientationLockType = Object.freeze({
    ANY: Symbol('any'),
    NATURAL: Symbol('natural'),
    LANDSCAPE: Symbol('landscape'),
    PORTRAIT: Symbol('portrait'),
    PORTRAIT_PRIMARY: Symbol('portrait-primary'),
    PORTRAIT_SECONDARY: Symbol('portrait-secondary'),
    LANDSCAPE_PRIMARY: Symbol('landscape-primary'),
    LANDSCAPE_SECONDARY: Symbol('landscape-secondary'),
})

// Navbar
export const NavbarHeight = document.getElementById('wrapper-navbar').offsetHeight || 0
